import {EventEmitter, Injectable, Output} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Router} from "@angular/router";
import {GlobalService} from "../services/global.service";
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {CaptchaComponent} from "../components/captcha/captcha.component";
import {Subject} from "rxjs/Subject";
import {PopBoxComponent} from "../components/pop-box/pop-box.component";
import {LoginModalComponent} from "../components/login-modal/login-modal.component";

@Injectable()
export class AccessIntereptor {

  waiting: boolean = false;

  private showAlert = new Subject<any>();

  private showConfirm = new Subject<any>();

  private showConfirm2 = new Subject<any>();

  private showMsg1 = new Subject<any>();


  // 消息提示内容
  msg: any;
  constructor(private router: Router, private globalService: GlobalService,
              private confirmServ: NzModalService, private showMsg: NzMessageService) {

    // 解决多次请求弹出多个弹出框的问题
    this.showAlert
      .debounceTime(1000)
      .subscribe(e => {
        this.confirmServ.open({
          zIndex: 5,
          content: CaptchaComponent,
          width: 360,
          footer: false,
          onCancel() {
          },
          onOk() {
          },
        });
      });

    let thiss = this;
    this.showConfirm
      .debounceTime(2000)
      .subscribe(e => {
        this.confirmServ.confirm({
          content: thiss.msg,
          onOk() {
            thiss.router.navigate(['']);
          },
          onCancel() {
          }
        });
      });

    this.showConfirm2
      .debounceTime(500)
      .subscribe(e => {
        this.confirmServ.open({
          zIndex: 4,
          content: LoginModalComponent,
          width: 360,
          footer: false,
          onOk() {
          },
          onCancel() {
          },
          // onOk() {
          //   thiss.router.navigate(['comLR/login']);
          // },
          // okText: '登录',
          // onCancel() {
          //   thiss.router.navigate(['comLR/register']);
          // },
          // cancelText: '注册'
        });
      });

    this.showMsg1
      .debounceTime(1500)
      .subscribe(e => {
        // 同一账号未进行修改密码的用户
        thiss.globalService.tokenChanged.next(1);
        if (thiss.globalService.modifyPwd == '0') {
          thiss.showMsg.error(thiss.msg);
          let isWho = this.globalService.userType;
          thiss.globalService.checkLoginState();
          thiss.globalService.deleteLocalStorage();
          thiss.globalService.isLoginedUser = false;

          if(isWho == 'enterprise'){
            thiss.router.navigate(['comLR/login'], {queryParams: {'selectIndex': '1'} });
          } else {
            thiss.router.navigate(['comLR/login'], {queryParams: {'selectIndex': '0'} });
          }
        } else {
          // 同一账号进行修改密码的用户
          thiss.globalService.modifyPwd = '0';
        }
      });
  }

  // 拦截请求的返回值
  intercept(observable: Observable<any>): Observable<any> {
    return Observable.create((observer) => {
      observable.subscribe(res => {
        let userType = this.globalService.getUserInfo("_userType");
        let code = res.code;
        // 获取token失败
        if (code == '40101' || code == '40102') {
          this.globalService.deleteLocalStorage();
          this.globalService.checkLoginState();
        } else if (code == '40301') { // token过期

          this.globalService.setUserInfo(JSON.stringify({'_userType': 'tourist'}));

          // 设置未读消息不显示
          this.globalService.setKey("countShow", false);

          if (userType == 'person' || userType == 'enterprise') {
            this.router.navigateByUrl("comLR/login");
          }

          this.globalService.deleteLocalStorage();
          this.globalService.checkLoginState();

          // 跳转到登录页重新登陆认证

        }  else if (code == '40302') {
          // 非法请求,黑名单,禁止访问
          this.msg = "您今天的查询次数已达上限，若需更多查询可联系客服咨询，客服电话：010-88052705。";
          this.showConfirm.next(1);
        } else if (code == '40303') {
          // 超出访问限制
          if (userType == "person" || userType == "enterprise") {
            this.msg = "您今天的查询次数已达上限，若需更多查询可联系客服咨询，客服电话：010-88052705。";
            this.showConfirm.next(1);
          } else {
            // 游客查询达到限制给登录注册提示
            this.msg = "您的查询次数达到上限，登录后可获得更多查询次数。";
            this.showConfirm2.next(1);
          }

          // 非法请求,ip超出访问数量
        } else if (code == '40304') {

          this.showAlert.next(1);
        } else if (code == '40500') {

          // 设置未读消息不显示
          this.globalService.setKey("countShow", false);

          // 登录密码已被修改，需要重新登录
          this.showMsg1.next(1);
          this.msg = "登录密码已被修改，请重新登录";
        }else {

          // 正确的请求
          observer.next(res);
        }
      }, (err) => {
        //this.router.navigateByUrl("");
        observer.error(err);
      }, () => {
        observer.complete();
      });
    });
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/interceptor/accessIntereptor.ts